import {handleAction} from 'uix/actions'
import {setLanguage} from './actions'
import {switchLanguageFormat} from 'uix/utils/format'

export const config = [
  handleAction(setLanguage, (config, action) => {
    let {dname, i18ndata, cacheKeys} = action.payload
    if (i18ndata && cacheKeys) {
      let ddata = config.ddata[dname]
      ddata = {
        ...ddata,
        i18n: {...ddata.i18n, ...i18ndata},
        cacheKeys: {...ddata.cacheKeys, ...cacheKeys},
      }

      return {
        ...config,
        ddata: {...config.ddata, [dname]: ddata},
      }
    }
    return config
  }),
]

export const meta = [
  handleAction(
    setLanguage,
    (meta, {payload}) => {
      switchLanguageFormat(payload.language)
      return {
        ...meta,
        language: payload.language,
        i18n: payload.i18ndata[payload.language],
      }
    },
    {language: null, i18n: null}
  ),
]
